/* Serialize Shopify cart writes across product cards, PDP and cart controls.
 * Section-rendering responses are snapshots: allowing two mutations to render
 * out of order can visually roll the drawer back to an older cart state. */
(function () {
  if (window.stocktechEnqueueCartMutation) return;

  var queue = Promise.resolve();
  window.stocktechEnqueueCartMutation = function (task) {
    var mutation = queue.catch(function () {}).then(task);
    queue = mutation.catch(function () {});
    return mutation;
  };
})();
